import React, { Component } from 'react';
import axios from 'axios';
import $ from "jquery";
import ConsultationOTP from '../commonFiles/ConsultationOTP';
class ConsultationForm extends Component {
  constructor() {
    super();
    this.save_free_consulting = this.save_free_consulting_data.bind(this);
    this.validate_otp_input = this.validate_email_mobile.bind(this);
    this.state = {
      send_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.save_free_consulting}>Send</button>,
      otp_inputs:'',
      token_id:'',
    };
  }

  componentDidMount() {
   this.get_free_captcha_code();
  }

get_free_captcha_code(){
  let cutThis = this;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('web_token',web_token);
   body.append('function','free_captcha_code');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/consultation_url.php";
   }else{
     url = "/php/consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var captcha_code = res.data;
      cutThis.create_captcha_code(captcha_code);
    })
    .catch(function (error) {
        console.log(error);
    });

}

  create_captcha_code(captcha_code){
    var font_name = 'Arial';
    var captcha_color = 'red';
    document.getElementById('free_captcha_code').innerHTML = "";
       var captcha = captcha_code;
       var canv = document.createElement("canvas");
       canv.id = "login_captcha_code_div";
       canv.width = 100;
       canv.height = 50;
       var ctx = canv.getContext("2d");
       ctx.font = font_name;
       ctx.font = '20px Verdana';
       ctx.strokeStyle = captcha_color;
       ctx.strokeText(captcha, 0, 30);
       document.getElementById("free_captcha_code").appendChild(canv);
  }

  save_free_consulting_data(){
    let cutThis         = this;
    var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Send...</button>;
    cutThis.setState({send_button});
    $('label').removeClass('color_red');
    var first_name      = window.isNullAndUndef($('#first_name').val());
    var last_name       = window.isNullAndUndef($('#last_name').val());
    var email           = window.isNullAndUndef($('#email').val());
    var mobile_no       = window.isNullAndUndef($('#mobile_no').val());
    var subject_matter  = window.isNullAndUndef($('#subject_matter').val());
    var message         = window.isNullAndUndef($('#message').val());
    var web_token       = window.isNullAndUndef($('#web_token').val());
    var code            = window.isNullAndUndef($('#code').val());
    var email_validate  = window.validateEmail($('#email').val());
    var mobile_validate = window.validateMobile($('#mobile_no').val());
    if(first_name && last_name && email && mobile_no && subject_matter && message && web_token && code && email_validate && mobile_validate && message.length<251){
      var body = new FormData();
      body.append('first_name',first_name);
      body.append('last_name',last_name);
      body.append('email',email);
      body.append('mobile_no',mobile_no);
      body.append('subject_matter',subject_matter);
      body.append('message',message);
      body.append('code',code);
      body.append('web_token',web_token);
      body.append('function','add_free_consulting_data');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/consultation_url.php";
      }else{
        url = "/php/consultation_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          var msg = data['msg'];
          if(data['code']==1){
            $('#freeConsultation input').attr('readonly', 'readonly');
            $('#freeConsultation textarea').attr('readonly', 'readonly');
            $('#subject_matter option:not(:selected)').attr('disabled', true);
            var token_id = data['token_id'];
            cutThis.setState({token_id});
            var otp_inputs = <ConsultationOTP/>;
            cutThis.setState({otp_inputs});
            send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.validate_otp_input}>Verify Email & Mobile</button>;
            cutThis.setState({send_button});
            $('#error_msg').text(msg).removeClass('hide');
          }else {
            $('#error_msg').text(msg).removeClass('hide').addClass('color_red');
          }
       })
       .catch(function (error) {
           console.log(error);
       });
    }else{
      window.change_lable_color('first_name','last_name','email','mobile_no','subject_matter','message','code');
      if(mobile_validate){$('#mobile_no').next('label').removeClass('color_red');}else{$('#mobile_no').next('label').addClass('color_red');}
      if(email_validate){$('#mobile_no').next('label').removeClass('color_red');}else{$('#email').next('label').addClass('color_red');}
      send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_free_consulting}>Send</button>;
      cutThis.setState({send_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }

  validate_email_mobile(){
    $('label').removeClass('color_red');
    let cutThis     = this;
    var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Validating OTP...</button>;
    cutThis.setState({send_button});
    var token_id    = cutThis.state.token_id;
    var email_otp   = window.isNullAndUndef($('#email_otp').val());
    //var mobile_otp  = window.isNullAndUndef($('#mobile_otp').val());
    var web_token   = window.isNullAndUndef($('#web_token').val());
    //if(!isNaN(email_otp) && !isNaN(mobile_otp) && email_otp && mobile_otp && email_otp.length==6 && mobile_otp.length==6){
    if(!isNaN(email_otp) && email_otp && email_otp.length==6){
      var body = new FormData();
      body.append('token_id',token_id);
      body.append('email_otp',email_otp);
      //body.append('mobile_otp',mobile_otp);
      body.append('web_token',web_token);
      body.append('function','check_create_account_free_consulting_user');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/consultation_url.php";
      }else{
        url = "/php/consultation_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          var msg = data['msg'];
          if(data['code']==1){
            var send_button     = '';
            cutThis.setState({send_button});
            $('#error_msg').text(msg).removeClass('hide');
            setTimeout(function () {
              window.location.href = "/login";
            }, 20010);
          }else {
            $('#error_msg').text(msg).removeClass('hide').addClass('color_red');
          }
       })
       .catch(function (error) {
         console.log(error);
       });
    }else{
      $('#email_otp').next('label').addClass('color_red');
      //$('#mobile_otp').next('label').addClass('color_red');
      send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.validate_otp_input}>Verify Email & Mobile</button>;
      cutThis.setState({send_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }

  render() {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <h1 className="text-center wow fadeInUp" data-wow-delay="0.1s">Free Consultation</h1>
                <div className="row g-4">

                 <div className="col-md-4"></div>

                    <div className="col-md-4">
                        <div className="wow fadeInUp" data-wow-delay="0.5s">
                            <p className="mb-4"></p>
                            <form action="" method="post" id="freeConsultation">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="first_name" name="first_name" placeholder="First Name"/>
                                            <label for="name">First Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="last_name" name="last_name" placeholder="Last Name"/>
                                            <label for="name">Last Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="email" name="email" placeholder="Your Email"/>
                                            <label for="name">Email</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" id="mobile_no" name="mobile_no" placeholder="Mobile Number" maxlength="10"/>
                                            <label for="email">Mobile Number</label>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="subject_matter" name="subject_matter" placeholder="Subject Matter" maxlength="50"/>
                                            <label for="email">Subject Matter</label>
                                        </div>
                                    </div>

                                    {/*<div className="col-md-12">
                                        <div className="form-floating">
                                            <select class="form-control form-select" id="subject_matter" name="subject_matter">
                                            <option value="">Subject Matter</option>
                                            <option value="Matter 1">Matter 1</option>
                                            <option value="Ma2ter 1">Matter 2</option>
                                            <option value="Matter 1">Matter 3</option>
                                        </select>
                                        <label for="name">Subject Matter</label>
                                        </div>
                                    </div>*/}

                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea className="form-control textarea-height" placeholder="Leave a message here" id="message" name="message" maxlength="250"></textarea>
                                            <label for="message">Message</label>
                                        </div>
                                    </div>


                                    <div className="col-5">
                                        <div className="form-floating">
                                            <p className="code-pm-zero">Code</p>
                                            <span id="free_captcha_code"></span>
                                        </div>
                                    </div>
                                    <div className="col-7">
                                        <div className="form-floating">
                                            <span onClick={() => this.get_free_captcha_code()}><i class="fa fa-2x fa fa-retweet text-primary reload-icon"></i></span>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="code" name="code" placeholder="Enter Code" maxlength="6"/>
                                            <label for="subject">Enter Code</label>
                                        </div>
                                    </div>


                                    {this.state.otp_inputs}


                                    <div className="col-md-12">
                                        <p className="hide" id="error_msg"></p>
                                        {this.state.send_button}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-md-4"></div>

                </div>
            </div>
        </div>
    );
  }
}

export default ConsultationForm;
